import * as yup from 'yup';

export const cajaPrimariaFormSchema = yup.object({
  nombre: yup.string()
    .required("Requerido")
      .matches(
      /^[A-Z]{3}\s\d*1$/,
      "Formato inválido. Debe ser 'ABC 12171' (3 letras, espacio, número terminado en 1)"
    ),
  tarjeta: yup.string().required("Requerido")
    .matches(
      /^(?:[0-9]|1[0-5])\/(?:[0-9]|1[0-5])\/(?:[0-9]|1[0-5])$/,
      "Formato inválido. Debe ser '0/1/2' (números del 0 al 15 separados por barras)"
    ),
  splitter: yup.string().required('El campo splitter es requerido'),
  // potencia_maxima: yup.string().required('El campo potencia máxima es requerido'),
  // potencia_minima: yup.string().required('El campo potencia mínima es requerido'),
  olt: yup.string().required('El campo olt es requerido'),
  // coordenadas: yup.string().required('El campo coordenadas es requerido'),
});
